export { default as SignUp } from './sign-up';
